<template>
  <div>
    <div class="row">
      <div class="col-xl-4">
        <!-- General Team Card -->

        <div class="card card-custom gutter-b " v-if="myTeam && levels">
          <div class="card-body d-flex flex-column">
            <div class="row">
              <div class="logo col-12 text-center">
                <img
                  v-if="myTeam.logo"
                  :src="'https://api.xupxup.net/' + myTeam.logo"
                  alt=""
                  width="100"
                />
              </div>
              <h1 class="card-title font-weight-bolder col-12 text-center mb-5">
                {{ myTeam.name }}
              </h1>
              <h5 class="text-center col-12 mt-0">
                <a :href="myTeam.url" target="_blank">{{ myTeam.url }}</a>
              </h5>
            </div>
            <div class="d-flex align-items-center pt-7">
              <div class="symbol symbol-45 symbol-light mr-4">
                <span class="symbol-label p-6">
                  <span class="text-dark">
                    <i class="fas fa-signal"></i>
                  </span>
                </span>
              </div>
              <div class="d-flex flex-column flex-grow-1">
                <span class="text-dark-75 mb-1 font-size-lg font-weight-bolder"
                  >Total points</span
                >
              </div>
              <span
                class="font-weight-bolder label label-xl label-light-success label-inline px-3 py-5 min-w-45px"
                >{{ totalPoints }}</span
              >
            </div>

            <!-- <div class="d-flex align-items-center pt-7">
              <div class="symbol symbol-45 symbol-light mr-4">
                <span class="symbol-label p-6 ux">
                  <span class="text-dark">
                    <i class="fas fa-drafting-compass port"></i>
                  </span>
                </span>
              </div>
              <div class="d-flex flex-column flex-grow-1">
                <span class="text-dark-75 mb-1 font-size-lg font-weight-bolder"
                  >UX</span
                >
              </div>
              <span
                class="font-weight-bolder label label-xl label-light-success label-inline px-3 py-5 min-w-45px"
                >{{ disseny }}</span
              >
            </div> -->
            <div
              class="d-flex align-items-center pt-7"
              v-for="p in teamPoints"
              :key="p._id"
            >
              <div class="symbol symbol-45 symbol-light mr-4">
                <span
                  class="symbol-label p-6 ui"
                  :style="'background-color:' + p.color"
                >
                  <span class="text-dark">
                    <i class="fas port" :class="p.image"></i>
                  </span>
                </span>
              </div>
              <div class="d-flex flex-column flex-grow-1">
                <span
                  class="text-dark-75 mb-1 font-size-lg font-weight-bolder"
                  >{{ p.name }}</span
                >
              </div>
              <span
                class="font-weight-bolder label label-xl label-light-success label-inline px-3 py-5 min-w-45px"
                >{{ p.points }}</span
              >
            </div>
            <!-- <div class="d-flex align-items-center pt-7">
              <div class="symbol symbol-45 symbol-light mr-4">
                <span class="symbol-label p-6 dev">
                  <span class="text-dark">
                    <i class="fas fa-code port"></i>
                  </span>
                </span>
              </div>
              <div class="d-flex flex-column flex-grow-1">
                <span class="text-dark-75 mb-1 font-size-lg font-weight-bolder"
                  >Developer</span
                >
              </div>
              <span
                class="font-weight-bolder label label-xl label-light-success label-inline px-3 py-5 min-w-45px"
                >{{ desenvolupament }}</span
              >
            </div>
            <div class="d-flex align-items-center pt-7">
              <div class="symbol symbol-45 symbol-light mr-4">
                <span class="symbol-label p-6 wp">
                  <span class="text-dark">
                    <i class="fas fa-laptop-code port"></i>
                  </span>
                </span>
              </div>
              <div class="d-flex flex-column flex-grow-1">
                <span class="text-dark-75 mb-1 font-size-lg font-weight-bolder"
                  >Wordpress</span
                >
              </div>
              <span
                class="font-weight-bolder label label-xl label-light-success label-inline px-3 py-5 min-w-45px"
                >{{ desenvolupament }}</span
              >
            </div> -->
          </div>
        </div>
      </div>

      <!-- Users List Card -->
      <div class="col-xl-8" style="padding-top:0">
        <div class="row">
          <div class="col-xl-6" v-for="i in TeamMembers" :key="i._id">
            <div>
              <div class="card card-custom gutter-b  p-10">
                <div class="d-flex align-items-end mb-7">
                  <div class="d-flex align-items-center">
                    <div class="flex-shrink-0 mr-4 mt-lg-0 mt-3">
                      <div class="symbol symbol-circle symbol-lg-75">
                        <img src="/media/svg/avatars/001-boy.svg" alt="image" />
                      </div>
                      <!-- <div class="symbol symbol-lg-75 symbol-circle symbol-primary d-none">
																<span class="font-size-h3 font-weight-boldest">JM</span>
                      </div>-->
                    </div>
                    <div class="d-flex flex-column">
                      <div class="text-dark font-weight-bold font-size-h4 mb-0">
                        {{ i.firstName }} {{ i.lastName }}
                      </div>
                      <div class="row">
                        <!-- Punts Totals -->
                        <!-- <span
                          class="font-weight-bold label label-inline label-success text-white mt-5 mr-2 ml-3"
                          v-for="p in i.points.profiles"
                          :key="p._id"
                        >{{p.points}} {{p.profile.name}}</span>-->
                        <!-- User Level -->
                        <!-- <span class="font-weight-bold label label-inline label-warning" v-if="users">{{users}}</span> -->
                      </div>
                    </div>
                  </div>
                </div>

                <div class="d-flex align-items-center pt-7">
                  <div class="symbol symbol-45 symbol-light mr-4">
                    <span class="symbol-label p-6">
                      <span class="text-dark">
                        <i class="fas fa-signal"></i>
                      </span>
                    </span>
                  </div>
                  <div class="d-flex flex-column flex-grow-1" v-if="users[0]">
                    <span
                      class="text-dark-75 mb-1 font-size-lg font-weight-bolder"
                      >Level</span
                    >
                    <span class="text-muted font-weight-bold">{{
                      users[0].levelName
                    }}</span>
                  </div>
                  <span
                    class="font-weight-bolder label label-xl label-light-success label-inline px-3 py-5 min-w-45px"
                    >{{ i.points.total }}</span
                  >
                </div>
                <div
                  class="d-flex align-items-center pt-7"
                  v-for="p in i.points.profiles"
                  :key="p._id"
                >
                  <div
                    class="symbol symbol-45 symbol-light mr-4"
                    v-if="p.profile.name == 'Developer'"
                  >
                    <span class="symbol-label p-6 dev">
                      <span class="text-dark">
                        <i class="fas fa-code port"></i>
                      </span>
                    </span>
                  </div>
                  <div
                    class="symbol symbol-45 symbol-light mr-4"
                    v-if="p.profile.name == 'User Experience Designer'"
                  >
                    <span class="symbol-label p-6 ux">
                      <span class="text-dark">
                        <i class="fas fa-drafting-compass port"></i>
                      </span>
                    </span>
                  </div>
                  <div
                    class="symbol symbol-45 symbol-light mr-4"
                    v-if="p.profile.name == 'User Interface Designer'"
                  >
                    <span class="symbol-label p-6 ui">
                      <span class="text-dark">
                        <i class="fas fa-paint-brush port"></i>
                      </span>
                    </span>
                  </div>

                  <div
                    class="symbol symbol-45 symbol-light mr-4"
                    v-if="p.profile.name == 'Wordpress Manager'"
                  >
                    <span class="symbol-label p-6 wp">
                      <span class="text-dark">
                        <i class="fas fa-laptop-code port"></i>
                      </span>
                    </span>
                  </div>
                  <div class="d-flex flex-column flex-grow-1">
                    <span
                      class="text-dark-75 mb-1 font-size-lg font-weight-bolder"
                      >{{ p.profile.name }}</span
                    >
                  </div>
                  <span
                    class="font-weight-bolder label label-xl label-light-success label-inline px-3 py-5 min-w-45px"
                    v-if="p.points"
                    >{{ p.points }}</span
                  >
                </div>

                <div v-if="currentUser.user.team === myTeam._id">
                  <!--  -->
                  <h4 class="my-10">Projects</h4>
                  <b-button
                    v-b-toggle="'active' + i._id"
                    class="m-1 mb-4 col-12 btn btn-light-succes"
                    >Active</b-button
                  >
                  <b-collapse
                    :id="'active' + i._id"
                    v-for="ins in i.instances"
                    :key="ins._id"
                  >
                    <div
                      class="d-flex align-items-center bg-light-warning rounded p-5 mb-9"
                      v-if="ins.cancelled === false && !ins.dateFinished"
                    >
                      <div class="d-flex flex-column flex-grow-1 mr-2">
                        <div
                          class="font-weight-bold text-dark-75 font-size-lg mb-1"
                        >
                          {{ ins.project.title }}
                        </div>
                      </div>
                      <div class="d-flex flex-column flex-grow-1 ml-25">
                        <div class="d-flex align-items-center">
                          <span class="symbol-label p-2 px-6">
                            <span class="text-dark">
                              <i class="fas fa-laptop-code project-warning"></i>
                            </span>
                          </span>

                          <span
                            class="font-weight-bolder text-warning  font-size-lg"
                            >{{ ins.project.points[0].points }}</span
                          >
                        </div>
                        <div class="d-flex align-items-center">
                          <span class="symbol-label p-2 px-6">
                            <span class="text-dark">
                              <i
                                class="fas fa-drafting-compass project-warning"
                              ></i>
                            </span>
                          </span>

                          <span
                            class="font-weight-bolder text-warning  font-size-lg"
                            >{{ ins.project.points[1].points }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </b-collapse>

                  <b-button
                    v-b-toggle="'done' + i._id"
                    class="m-1 mb-4 col-12 btn btn-light-succes"
                    >Done</b-button
                  >
                  <b-collapse
                    :id="'done' + i._id"
                    v-for="ins in i.instances"
                    :key="ins._id"
                  >
                    <div
                      class="d-flex align-items-center bg-light-danger rounded p-5 mb-9"
                      v-if="ins.cancelled === true"
                    >
                      <div class="d-flex flex-column flex-grow-1 mr-2">
                        <!-- v-if="ins.cancelled === true" -->
                        <div
                          class="font-weight-bold text-dark-75  font-size-lg mb-1"
                        >
                          {{ ins.project.title }}
                        </div>
                      </div>
                      <div class="d-flex flex-column flex-grow-1 ml-25">
                        <div class="d-flex align-items-center">
                          <span class="symbol-label p-2 px-6">
                            <span class="text-dark">
                              <i class="fas fa-laptop-code project-denger"></i>
                            </span>
                          </span>

                          <span
                            class="font-weight-bolder text-danger py-1 font-size-lg"
                            >{{ ins.project.points[0].points }}</span
                          >
                        </div>
                        <div class="d-flex align-items-center">
                          <span class="symbol-label p-2 px-6">
                            <span class="text-dark">
                              <i
                                class="fas fa-drafting-compass project-denger"
                              ></i>
                            </span>
                          </span>

                          <span
                            class="font-weight-bolder text-danger  font-size-lg"
                            >{{ ins.project.points[1].points }}</span
                          >
                        </div>
                      </div>
                    </div>
                    <div
                      class="d-flex align-items-center bg-light-success rounded p-5 mb-9"
                      v-else-if="ins.dateFinished"
                    >
                      <div class="d-flex flex-column flex-grow-1 mr-2">
                        <div
                          class="font-weight-bold text-dark-75 font-size-lg mb-1"
                        >
                          {{ ins.project.title }}
                        </div>
                      </div>
                      <div class="d-flex flex-column flex-grow-1 ml-25">
                        <div class="d-flex align-items-center">
                          <span class="symbol-label p-2 px-6">
                            <span class="text-dark">
                              <i class="fas fa-laptop-code project-succes"></i>
                            </span>
                          </span>

                          <span
                            class="font-weight-bolder text-success font-size-lg"
                            >{{ ins.project.points[0].points }}</span
                          >
                        </div>
                        <div class="d-flex align-items-center">
                          <span class="symbol-label p-2 px-6">
                            <span class="text-dark">
                              <i
                                class="fas fa-drafting-compass project-succes"
                              ></i>
                            </span>
                          </span>

                          <span
                            class="font-weight-bolder text-success  font-size-lg"
                            >{{ ins.project.points[1].points }}</span
                          >
                        </div>
                      </div>
                    </div>
                  </b-collapse>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import "@/core/plugins/collapse";
//import axios from "axios";

//var id;

export default {
  name: "teams-single",
  components: {},
  data() {
    return {
      hover: false,
      //teams: [],
      percentatge: {},
      users: [],
      TeamMembers: [],
      puntsdis: {},
      // levels: {},
      //percent:[],

      disseny: 10,
      desenvolupament: 20,
      series: []
      // chartOptions: {
      //   chart: {
      //     height: 350,
      //     type: "radialBar"
      //   },

      //   plotOptions: {
      //     radialBar: {
      //       hollow: {
      //         size: 70
      //       }
      //     }
      //   }
      // }
    };
  },
  created() {
    // id = this.$route.params.teamId;
    // axios
    //    .get("teams/" + id + "?fields=users-points.profiles.profile")
    //    .then(response => {
    //      this.myteams = response.data;
    // console.log("My Team", this.myTeam);
    // let punts = 0;
    // let dissenygrup = 0;
    // let desenvolupamentgrup = 0;
    // for (let z = 0; z < this.teams.users.length; z++) {
    //   punts = punts + this.teams.users[z].points.total;
    //   dissenygrup = dissenygrup + this.teams.users[z].points.profiles[0].points;
    //   desenvolupamentgrup =
    //     desenvolupamentgrup + this.teams.users[z].points.profiles[1].points;
    // }
    // this.series.push(punts);
    // this.disseny = dissenygrup;
    // this.desenvolupament = desenvolupamentgrup;
    // console.log("Disseny", this.disseny);
    // console.log("Puns", this.series);
    //  axios.get("levels/").then(response => {
    //    this.levels = response.data;
    // for (let y = 0; y < this.teams.users.length; y++) {
    //   let level = {};
    //   // let percentatge=0;
    //   for (let x = 0; x < this.levels.length; x++) {
    //     if (this.levels[x].points <= this.teams.users[y].points.total) {
    //       level = {
    //         level: x,
    //         levelName: this.levels[x].name,
    //         user: this.teams.users[y].userName
    //       };
    //     }
    //   }
    // percentatge = this.teams.users[y].points.total / this.levels[x].points * 100
    // this.users.push(level);
    //}
    // console.log('PERCENTATGE', this.percent)
    //console.log("users", this.users);
    //});
    // });
    // axios
    //   .get(
    //     "users" +
    //       "?fields=points.profiles.profile, instances-project&filter=team:" +
    //       id
    //   )
    //   .then(response => {
    //     this.TeamMembers = response.data;
    //     console.log("PUNTSPROJECT", this.projectepunts);
    //     console.log("TEAMMEMBER", this.TeamMembers);
    //   });
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Teams" }]);
    console.log("CURRENT USER", this.currentUser);
    console.log("CURRENT", this.currentUser.user.team);
  },

  computed: {
    myTeam() {
      console.log(this.$store.getters.getMyTeam);
      return this.$store.getters.getMyTeam;

      // return team;
    },
    totalPoints() {
      let total = 0;
      for (let i = 0; i < this.myTeam.users.length; i++) {
        total = this.myTeam.users[i].points.total;
      }
      return total;
    },
    teamPoints() {
      let points = this.profiles;
      points.forEach(i => (i.points = 0));
      console.log("myTeams in teamPoints", this.myTeam);
      for (let i = 0; i < this.myTeam.users.length; i++) {
        for (let j = 0; j < this.myTeam.users[i].points.profiles.length; j++) {
          //console.log("PP", this.myTeam.users[i].points.profiles[j].profile);
          console.log("prof", points);
          points.forEach((element, index) => {
            console.log(element);
            if (
              element._id === this.myTeam.users[i].points.profiles[j].profile
            ) {
              points[index].points += this.myTeam.users[i].points.profiles[
                j
              ].points;
            }
          });
        }
        //points.push(punts.points);
      }
      console.log("points", points);
      return points;
    },
    levels() {
      return this.$store.getters.getLevels;
    },
    profiles() {
      return this.$store.getters.getProfiles;
    },
    ...mapGetters(["currentUser"])
  }
};
</script>

<style>
/* .apexcharts-radialbar-area.apexcharts-radialbar-slice-0 {
  fill: none;
  fill-opacity: 0.85;
  stroke: rgba(27, 197, 189, 0.85);
  stroke-opacity: 1;
  stroke-linecap: round !important;
  stroke-width: 10.852439024390247px;
  stroke-dasharray: 0px;
}

.btn.btn-light-succes {
  background-color: transparent;
  color: #0bb7af;
  border: 1px solid #0bb7af;
}
.btn.btn-light-succes:hover {
  background-color: #0bb7af !important;
  color: white !important;
  border: 1px solid #0bb7af !important;
}
.card.card-custom.card-stretch.gutter-b {
  height: auto !important;
}


path#apexcharts-radialbarTrack-0.apexcharts-radialbar-area {
  fill: none;
  fill-opacity: 1;
  stroke: rgba(201, 247, 245, 0.85);
  stroke-opacity: 1;
  stroke-linecap: round;
  stroke-width: 10.852439024390247px;
  stroke-dasharray: 0px;
}
.apexcharts-text.apexcharts-datalabel-value {
  font-family: Helvetica, Arial, sans-serif;
  text-anchor: middle;
  dominant-baseline: auto;
  font-size: 30px;
  font-weight: 700;
  fill: rgb(70, 78, 95);
  margin-top: -20px;
}
.apexcharts-text.apexcharts-datalabel-label {
  display: none;
}
i {
  color: #6cc5a5;
} */
</style>
